// @flow
import React, { type Node } from 'react'
import './styles.scss'

export function Rail ({
  className,
  children,
  left = false
}: {
  className?: string,
  children: Node,
  left: boolean
}) {
  const side = left ? 'left' : 'right'
  return <aside className={`ta ${className} ${side} rail`}>{children}</aside>
}
